import Vue from "vue";
import VueRouter from "vue-router";
import M from "@/libs/mapping.js";
import { CAFE24_ROUTES } from "./cafe24.js";
import { SHOPLUS_ROUTES } from "./shoplus.js";

import SetStoreInfo from "@/libs/authservice/setting-store-info.js";

Vue.use(VueRouter);

//url path 앞자리 ( ex : http://localhost:8080/shoplus_service => shoplus_service )
let path = M.urlPath();

//url get parameter 체크해서 appCode 세팅
let appCode = M.getUrlParameter("app_code");
if (appCode) {
  appCode = appCode.toLowerCase();
}

//url get parameter 체크해서 mallType 세팅
let mallType = M.getUrlParameter("mType");
if (mallType) {
  mallType = mallType.toLowerCase();
}

//routes 배열 담을 변수
let routeArray = [];

/**
 * 경로에 따른 routes
 */
switch (path) {
  case "shoplus_service":
  case "shoplus_authservice":
    routeArray = SHOPLUS_ROUTES;
    break;
  default:
    routeArray = CAFE24_ROUTES;
    break;
}

const routes = routeArray;
const router = new VueRouter({
  mode: "history",
  routes,
});

/**
 * store 정보 세팅 및 네비게이션 가드 처리를 SetStoreInfo에서 통합 관리
 */
new SetStoreInfo(router, path, appCode, mallType);

export default router;
